import { Link, NavLink } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useT } from "../i18n/I18nProvider";

export const MobileMenu = ({ navItems }) => {
  const t = useT();

  return (
    <div className="md:hidden border-t border-ink-200 bg-cream/95 backdrop-blur-xl">
      <div className="px-6 py-6 flex flex-col gap-4">
        {navItems.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            data-testid={`mnav-${n.key}`}
            className={({ isActive }) =>
              `font-display text-2xl ${isActive ? "text-ink-900" : "text-ink-500"}`
            }
          >
            {n.label}
          </NavLink>
        ))}
        <Link to="/contatti" className="btn-pill mt-4 w-fit" data-testid="mnav-contact">
          {t("nav.parliamone")} <ArrowUpRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </div>
  );
};
